import { TESTIMONIALS, CLINIC } from "../data/clinic";
import { useLang } from "../i18n/LanguageContext";
import { Reveal, Eyebrow, Stars } from "./Reveal";
import { Quote, ArrowUpRight } from "lucide-react";

export default function Testimonials() {
  const { t } = useLang();
  const ts = t.testimonials;

  return (
    <section data-testid="testimonials-section" className="relative overflow-hidden bg-brand-surface py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <Eyebrow>{ts.eyebrow}</Eyebrow>
          <div className="mt-5 flex flex-col justify-between gap-4 md:flex-row md:items-end">
            <h2 className="max-w-2xl font-display text-4xl font-normal leading-tight tracking-tight text-brand-ink md:text-5xl">
              {ts.heading}
            </h2>
            <div className="flex flex-col items-start gap-3 md:items-end">
              <div className="flex items-center gap-3">
                <Stars />
                <span className="text-sm font-medium text-brand-inksoft">{ts.rating}</span>
              </div>
              <a
                href={CLINIC.googleBusiness}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="google-reviews-btn"
                aria-label={`${t.common.readGoogleReviews} — ${CLINIC.name}`}
                className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-primary transition-colors hover:text-brand-primaryHover"
              >
                {t.common.readGoogleReviews} <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>
          </div>
        </Reveal>
      </div>

      <div
        data-testid="testimonials-scroller"
        className="mt-14 flex snap-x snap-mandatory gap-6 overflow-x-auto px-5 pb-6 lg:px-8"
        style={{ scrollbarWidth: "thin" }}
      >
        {TESTIMONIALS.map((tst, i) => (
          <Reveal key={tst.name} delay={(i % 3) * 0.08}>
            <figure data-testid={`testimonial-card-${i}`} className="flex h-full w-[300px] shrink-0 snap-start flex-col rounded-3xl border border-brand-border bg-brand-bg p-7 md:w-[380px]">
              <Quote className="h-8 w-8 text-brand-warm/50" strokeWidth={1.5} />
              <Stars className="mt-4" />
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-brand-ink">
                {tst.text}
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-brand-border pt-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-primary font-display text-lg text-white">
                  {tst.name.charAt(0)}
                </span>
                <span className="font-semibold text-brand-ink">{tst.name}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
